import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    wrapper: 'relative',
  },
  styles: {
    wrapper: {},
  },
}));
